import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UserVideoView from "../UserVideoView/UserVideoView";
import { editRepResult } from "../../services/EditReportServices";
import Loader from "../Common/Loader/Loader";
import SuccessMessage from "../SuccessMessage/SuccessMessage";
import bulb from "../../assets/Icons/bulb.svg";
import HintMessage from "../Common/HintMessage/HintMessage";

const EditRepReport = ({ modalData, open, handleClose, handleOpen }) => {
  const { sessionId, userId } = useParams();
  const [success, setSuccess] = useState(false);
  const [successRes, setSuccessRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [defaultValues, setDefaultValues] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const querySessionId = queryParams.get("session_id");
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors, isDirty },
    setValue,
  } = useForm({
    mode: "onSubmit",
    defaultValues: {
      defaultValues,
    },
  });
  const editing_reason = watch("editing_reason");

  useEffect(() => {
    setDefaultValues({
      improvement_opportunity_level:
        modalData.interpretation_config.interpretation,
      editing_reason: modalData.editing_reason,
      editing_comment: modalData.editing_comment,
    });
  }, [modalData]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) =>
      console.log(value, name, type)
    );
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (editing_reason !== "Other") {
      setValue("editing_comment", "");
    }
  }, [editing_reason]);

  const onSubmit = (data) => {
    console.log("data", data);
    const assessment_output_list = [];
    if (data.front_view_assessment_report_for_reps) {
      const front_res = {
        exercise_id:
          modalData.front_view_assessment_report_for_reps
            .exercise_output_for_rep.exercise_id,
        value:
          modalData.front_view_assessment_report_for_reps
            .exercise_output_for_rep.value,
        reps_stats_list: [
          {
            rep_number: 1,
            rep_details_list: [],
          },
        ],
      };
      const front_view_assessment_report_for_reps =
        data.front_view_assessment_report_for_reps;
      for (const key in front_view_assessment_report_for_reps) {
        if (
          Object.hasOwnProperty.call(front_view_assessment_report_for_reps, key)
        ) {
          const element = front_view_assessment_report_for_reps[key];
          front_res.reps_stats_list[0].rep_details_list.push({
            title: key,
            value: element,
          });
        }
      }
      assessment_output_list.push(front_res);
    }
    if (data.side_view_assessment_report_for_reps) {
      const side_res = {
        exercise_id:
          modalData.side_view_assessment_report_for_reps.exercise_output_for_rep
            .exercise_id,
        value:
          modalData.side_view_assessment_report_for_reps.exercise_output_for_rep
            .value,
        reps_stats_list: [
          {
            rep_number: 1,
            rep_details_list: [],
          },
        ],
      };
      const side_view_assessment_report_for_reps =
        data.side_view_assessment_report_for_reps;
      for (const key in side_view_assessment_report_for_reps) {
        if (
          Object.hasOwnProperty.call(side_view_assessment_report_for_reps, key)
        ) {
          const element = side_view_assessment_report_for_reps[key];
          side_res.reps_stats_list[0].rep_details_list.push({
            title: key,
            value: element,
          });
        }
      }
      assessment_output_list.push(side_res);
    }
    const reqPayload = {
      encrypted_session_id: sessionId ? sessionId : querySessionId,
      edited_interpretation: data.improvement_opportunity_level,
      editing_reason: data.editing_reason,
      // editing_reason: null,
      editing_comment: data.editing_comment,
      // editing_comment: null,
      assessment_output_list: assessment_output_list,
    };
    console.log("reqPayload", reqPayload);
    setLoading(true);
    editRepResult(reqPayload).then((res) => {
      if (res.data.code === 2000) {
        setSuccess(true);
        setSuccessRes(res.data.data);
        setLoading(false);
      }
    });
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          width: "665px",
          // maxHeight: '80vh',
          // height: 'auto',
          borderRadius: "20px",
        }}
      >
        {!success && (
          <div className="rounded-[20px] overflow-auto">
            <div className="h-[60px] bg-[#EFF4FF] flex items-center justify-between pl-6 pr-6">
              <div className="text-[#101828] text-sm leading-5 font-medium">
                Exercise Preview
              </div>
              <div>
                <CloseIcon
                  sx={{
                    height: "14px",
                    width: "14px",
                    color: "#415280",
                    opacity: "0.8",
                    cursor: "pointer",
                  }}
                  onClick={handleClose}
                />
              </div>
            </div>
            {!loading && (
              <>
                <div
                  style={{
                    maxHeight: "80vh",
                    overflow: "scroll",
                    height: "auto",
                  }}
                >
                  <div className="pl-6 pr-6">
                    <div className="flex justify-between mt-7">
                      <div className="text-[#101828]  font-semibold text-base leading-6">
                        {modalData.assessment_name.toUpperCase()}(Front View)
                      </div>
                      <div className="flex items-center">
                        <div className="text-[#101828]  font-medium text-xs leading-4">
                          Improvement Opportunity Level
                        </div>
                        <div className="flex items-center ml-2 bg-[#F0F0F0] gap-[5px] py-1 px-2 rounded-[18px]">
                          <div
                            className="w-[6px] h-[6px] rounded-[50%]"
                            style={{
                              backgroundColor:
                                modalData.interpretation_config.font_color_code,
                            }}
                          ></div>
                          <div className="font-medium text-xs leading-[18px]">
                            {modalData.interpretation_config.interpretation}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-[18px] mt-[14px]">
                      <UserVideoView
                        sessionId={sessionId ? sessionId : querySessionId}
                        userId={userId}
                        exerciseId={
                          modalData.front_view_assessment_report_for_reps
                            .exercise_output_for_rep.exercise_id
                        }
                      />
                    </div>
                    <div>
                      <Accordion>
                        <AccordionSummary
                          sx={{
                            backgroundColor: "#415280",
                            borderRadius: "5px",
                            color: "#fff",
                          }}
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color: "#fff",
                              }}
                            />
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <div className="text-xs leading-[14px] font-medium">
                            Legend
                          </div>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            border: "1px solid #F0F0F0",
                            padding: "0px",
                          }}
                        >
                          {modalData.front_view_assessment_report_for_reps &&
                            modalData.front_view_assessment_report_for_reps
                              .exercise_output_for_rep &&
                            modalData.front_view_assessment_report_for_reps
                              .exercise_output_for_rep.rep_stats_list[0] &&
                            modalData.front_view_assessment_report_for_reps.exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_accuracy_parameter_details_list.map(
                              (item, index) => (
                                <div
                                  className="flex items-center justify-between pl-[52px] border-b border-solid border-[#F0F0F0]"
                                  key={index}
                                >
                                  <div className="text-[#415280] text-xs leading-[14px] font-normal">
                                    {item.title}
                                  </div>
                                  <div className="flex text-[#3F3D56] text-xs leading-[14px] gap-[10px] font-normal">
                                    <div className="w-28 text-center">
                                      {index === 0 && (
                                        <div className="w-28 h-[5px] bg-[#119F28]"></div>
                                      )}
                                      {item.low_interpretation_legends &&
                                        item.low_interpretation_legends.map(
                                          (item, index) => (
                                            <>
                                              <div className="py-2" key={index}>
                                                {item.legend}
                                              </div>
                                            </>
                                          )
                                        )}
                                    </div>
                                    <div className="w-28 text-center">
                                      {index === 0 && (
                                        <div className="w-28 h-[5px] bg-[#FFB800]"></div>
                                      )}
                                      {item.moderate_interpretation_legends &&
                                        item.moderate_interpretation_legends.map(
                                          (item, index) => (
                                            <div key={index}>{item.legend}</div>
                                          )
                                        )}
                                    </div>
                                    <div className="w-28 text-center">
                                      {index === 0 && (
                                        <div className="w-28 h-[5px] bg-[#F04438]"></div>
                                      )}
                                      {item.high_interpretation_legends &&
                                        item.high_interpretation_legends.map(
                                          (item, index) => (
                                            <div key={index}>{item.legend}</div>
                                          )
                                        )}
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="mt-2 mb-5">
                      <table className="w-full border-separate border-spacing-x-0 border-spacing-y-1">
                        <thead>
                          <tr className="bg-[#415280] rounded-[5px] h-[30px]">
                            <th className="w-[288px]"></th>
                            <th className="text-center text-[#fff] text-xs leading-4 font-medium">
                              Measured
                            </th>
                            <th className="text-left text-[#fff] text-xs leading-4 font-medium">
                              Adjusted
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalData.front_view_assessment_report_for_reps &&
                            modalData.front_view_assessment_report_for_reps
                              .exercise_output_for_rep &&
                            modalData.front_view_assessment_report_for_reps
                              .exercise_output_for_rep.rep_stats_list[0] &&
                            modalData.front_view_assessment_report_for_reps.exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_accuracy_parameter_details_list.map(
                              (item, index) => (
                                <tr className="bg-[#F0F0F0]" key={index}>
                                  <td className="py-3 pl-6 text-xs font-medium leading-4">
                                    {item.title}
                                  </td>
                                  <td className="text-center text-[#101828] text-xs leading-4 font-medium py-3">
                                    {item.value}
                                  </td>
                                  <td className="py-2">
                                    <input
                                      type="number"
                                      className="w-[50px] h-6 text-center text-xs bg-transparent font-semibold border border-solid border-[#605F5F] rounded-[2px]"
                                      defaultValue={item.value}
                                      {...register(
                                        `front_view_assessment_report_for_reps.${item.title}`,
                                        {
                                          // required: true,
                                          min: 0,
                                        }
                                      )}
                                    />
                                  </td>
                                </tr>
                              )
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="pl-6 pr-6">
                    <div className="flex justify-between mt-7">
                      <div className="text-[#101828]  font-semibold text-base leading-6">
                        {modalData.assessment_name.toUpperCase()}(Side View)
                      </div>
                      <div className="flex items-center">
                        <div className="text-[#101828]  font-medium text-xs leading-4">
                          Improvement Opportunity Level
                        </div>
                        <div className="flex items-center ml-2 bg-[#F0F0F0] gap-[5px] py-1 px-2 rounded-[18px]">
                          <div
                            className="w-[6px] h-[6px] rounded-[50%]"
                            style={{
                              backgroundColor:
                                modalData.interpretation_config.font_color_code,
                            }}
                          ></div>
                          <div className="font-medium text-xs leading-[18px]">
                            {modalData.interpretation_config.interpretation}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-[18px] mt-[14px]">
                      <UserVideoView
                        sessionId={sessionId  ? sessionId : querySessionId}
                        userId={userId}
                        exerciseId={
                          modalData.side_view_assessment_report_for_reps
                            .exercise_output_for_rep.exercise_id
                        }
                      />
                    </div>
                    <div>
                      <Accordion>
                        <AccordionSummary
                          sx={{
                            backgroundColor: "#415280",
                            borderRadius: "5px",
                            color: "#fff",
                          }}
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                color: "#fff",
                              }}
                            />
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <div className="text-xs leading-[14px] font-medium">
                            Legend
                          </div>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            border: "1px solid #F0F0F0",
                            padding: "0px",
                          }}
                        >
                          {modalData.side_view_assessment_report_for_reps &&
                            modalData.side_view_assessment_report_for_reps
                              .exercise_output_for_rep &&
                            modalData.side_view_assessment_report_for_reps
                              .exercise_output_for_rep.rep_stats_list[0] &&
                            modalData.side_view_assessment_report_for_reps.exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_accuracy_parameter_details_list.map(
                              (item, index) => (
                                <div
                                  className="flex items-center justify-between pl-[52px] border-b border-solid border-[#F0F0F0]"
                                  key={index}
                                >
                                  <div className="text-[#415280] text-xs leading-[14px] font-normal">
                                    {item.title}
                                  </div>
                                  <div className="flex text-[#3F3D56] text-xs leading-[14px] gap-[10px] font-normal">
                                    <div className="w-28 text-center">
                                      {index === 0 && (
                                        <div className="w-28 h-[5px] bg-[#119F28]"></div>
                                      )}
                                      {item.low_interpretation_legends &&
                                        item.low_interpretation_legends.map(
                                          (item, index) => (
                                            <div key={index} className="py-2">
                                              {item.legend}
                                            </div>
                                          )
                                        )}
                                    </div>
                                    <div className="w-28 text-center">
                                      {index === 0 && (
                                        <div className="w-28 h-[5px] bg-[#FFB800]"></div>
                                      )}
                                      {item.moderate_interpretation_legends &&
                                        item.moderate_interpretation_legends.map(
                                          (item, index) => (
                                            <div key={index} className="py-2">
                                              {item.legend}
                                            </div>
                                          )
                                        )}
                                    </div>
                                    <div className="w-28 text-center">
                                      {index === 0 && (
                                        <div className="w-28 h-[5px] bg-[#F04438]"></div>
                                      )}
                                      {item.high_interpretation_legends &&
                                        item.high_interpretation_legends.map(
                                          (item, index) => (
                                            <div key={index} className="py-2">
                                              {item.legend}
                                            </div>
                                          )
                                        )}
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <div className="mt-2 mb-5">
                      <table className="w-full border-separate border-spacing-x-0 border-spacing-y-1">
                        <thead>
                          <tr className="bg-[#415280] rounded-[5px] h-[30px]">
                            <th className="w-[288px]"></th>
                            <th className="text-center text-[#fff] text-xs leading-4 font-medium">
                              Measured
                            </th>
                            <th className="text-left text-[#fff] text-xs leading-4 font-medium">
                              Adjusted
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalData.side_view_assessment_report_for_reps &&
                            modalData.side_view_assessment_report_for_reps
                              .exercise_output_for_rep &&
                            modalData.side_view_assessment_report_for_reps
                              .exercise_output_for_rep.rep_stats_list[0] &&
                            modalData.side_view_assessment_report_for_reps.exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_accuracy_parameter_details_list.map(
                              (item, index) => (
                                <tr className="bg-[#F0F0F0]" key={index}>
                                  <td className="pl-[22px] py-3 text-xs font-medium leading-4">
                                    {item.title}
                                  </td>
                                  <td className="text-center text-[#101828] text-xs leading-4 font-medium py-3">
                                    {item.value}
                                  </td>
                                  <td className="py-2">
                                    <input
                                      type="number"
                                      className="w-[50px] h-6 text-center text-xs bg-transparent font-semibold border border-solid border-[#605F5F] rounded-[2px]"
                                      defaultValue={item.value}
                                      {...register(
                                        `side_view_assessment_report_for_reps.${item.title}`,
                                        {
                                          // required: true,
                                          min: 0,
                                        }
                                      )}
                                    />
                                  </td>
                                </tr>
                              )
                            )}
                        </tbody>
                      </table>
                    </div>
                    <div className="my-5">
                      <div className="bg-[#415280] py-2 pl-6 text-[#FFFFFF] rounded-[5px] text-xs leading-[14px] font-medium">
                        Improvement Opportunity Level
                      </div>
                      <div className="flex items-center mt-2">
                        <div className="w-2/5 text-xs leading-4 font-medium">
                          Improvement Opportunity Level Adjusted
                        </div>
                        <Controller
                          name="improvement_opportunity_level"
                          control={control}
                          rules={{ required: true }}
                          defaultValue={
                            modalData.interpretation_config.interpretation
                          }
                          render={({ field }) => (
                            <Select
                              {...field}
                              className="w-3/5 h-9"
                              sx={{
                                fontSize: "12px",
                                lineHeight: "16px",
                              }}
                              value={field.value || ""}
                              renderValue={(value) => (
                                <div className="flex">
                                  {modalData.improvement_opportunity_list.map(
                                    (item) => {
                                      console.log("item", item);
                                      if (item.interpretation == value) {
                                        return (
                                          <div
                                            className="rounded-sm text-xs py-1 px-4 font-medium"
                                            style={{
                                              backgroundColor:
                                                item.background_color_code,
                                              color: item.font_color_code,
                                            }}
                                          >
                                            {value}
                                          </div>
                                        );
                                      }
                                    }
                                  )}
                                </div>
                              )}
                            >
                              {modalData.improvement_opportunity_list.map(
                                (item, index) => {
                                  return (
                                    <MenuItem
                                      sx={{
                                        fontSize: "12px",
                                        lineHeight: "16px",
                                      }}
                                      key={index}
                                      value={item.interpretation}
                                    >
                                      {item.interpretation}
                                    </MenuItem>
                                  );
                                }
                              )}
                            </Select>
                          )}
                        />
                      </div>
                      <div className="flex items-center mt-2">
                        <div className="w-2/5 text-xs leading-4 font-medium">
                          Reason for Change
                        </div>
                        <Controller
                          name="editing_reason"
                          control={control}
                          defaultValue={modalData.editing_reason}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              value={field.value || ""}
                              className="w-3/5 h-9"
                              sx={{
                                fontSize: "12px",
                                lineHeight: "16px",
                              }}
                            >
                              {modalData.interpretation_edit_reason_list.map(
                                (item, index) => {
                                  return (
                                    <MenuItem
                                      sx={{
                                        fontSize: "12px",
                                        lineHeight: "16px",
                                      }}
                                      key={index}
                                      value={item.reason}
                                    >
                                      {item.reason}
                                    </MenuItem>
                                  );
                                }
                              )}
                            </Select>
                          )}
                        />
                      </div>
                      {isDirty && errors.editing_reason && (
                        <HintMessage
                          imgUrl={bulb}
                          msg="Please select Reason for listing any Change"
                        />
                      )}
                      {errors.editing_comment && editing_reason === "Other" && (
                        <HintMessage
                          imgUrl={bulb}
                          msg="  Mentioning Reason for Change is Mandatory to move
                        ahead"
                        />
                      )}
                      {editing_reason === "Other" && (
                        <div className="flex items-center mt-2">
                          <div className="w-2/5 text-xs leading-4 font-medium">
                            If Other
                          </div>
                          <Controller
                            name="editing_comment"
                            control={control}
                            defaultValue={modalData.editing_comment}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                className="w-3/5"
                                variant="outlined"
                                value={field.value || ""}
                                placeholder="Type Here..."
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 36,
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="border border-solid border-[#E9E9E9]">
                  <div className="flex items-center justify-end pl-6 pr-6 gap-2 mt-3 mb-4">
                    <Button
                      onClick={handleClose}
                      sx={{
                        backgroundColor: "#DF0F00",
                        color: "#fff",
                        borderRadius: "5px",
                        "&:hover": {
                          backgroundColor: "#DF0F00",
                          color: "#fff",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit(onSubmit)}
                      sx={{
                        backgroundColor: "#788CFC",
                        color: "#fff",
                        borderRadius: "5px",
                        "&:hover": {
                          backgroundColor: "#788CFC",
                          color: "#fff",
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </>
            )}
            {loading && <Loader />}
          </div>
        )}
        {success && <SuccessMessage data={successRes} close={handleClose} />}
      </Box>
    </Modal>
  );
};

export default EditRepReport;
